export default {
    url: '/topics',
    template: '<materials-topics/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/materials/topics/index.js